export default __webpack_public_path__ + "static/media/pic4.1a0c2af7.jpg";